const INITIAL_STATE = {
  data: {},
  errors: {},
      
}
const getUserList = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_USER_LIST_SUCCESSFULLY':
    return { ...INITIAL_STATE, data: action.data }
  case 'GET_USER_LIST_FAILED':
    return { ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default getUserList;